import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';

import { ApartmentSearchSortType } from '../../enums/ApartmentSearchSortType';
import { ApartmentSearchSortDirection } from '../../enums/ApartmentSearchSortDirection';

@Component
export class ApartmentPriceTableHeaderCell extends BaseComponent {
	@Prop() resourceName: string;
	@Prop() sortType: ApartmentSearchSortType;

	get searchSort() {
		return parseInt(this.$route.query.sort) as ApartmentSearchSortType;
	}

	get searchSortDirection() {
		return parseInt(this.$route.query.sortDirection) as ApartmentSearchSortDirection;
	}

	get sortable() {
		return Boolean(this.sortType);
	}

	sort() {
		if (!this.sortable) {
			return;
		}

		this.$router.push({path: this.$route.path, query: {
			...this.$route.query,
			sort: this.sortType.toString(),
			sortDirection: this.searchSort !== this.sortType || this.searchSortDirection === ApartmentSearchSortDirection.Down
				? ApartmentSearchSortDirection.Up.toString()
				: ApartmentSearchSortDirection.Down.toString()
		}});
	}
}

export default ApartmentPriceTableHeaderCell;
